<template>
<div class="inpBox">
  <div class="detailsTitle">
    <h4>新建订单</h4>
    <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
  <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
    <el-form-item label="结算客户 :" prop="payee" class="width1" label-width="120px">
      <el-select  v-model="goodform.payee" filterable placeholder="请选择" @change="jiesuanChange">
        <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="外部单号:" label-width="120px" class="width1">
      <el-input  placeholder=""    maxlength="50" v-model="goodform.externalOrderNumber"  ></el-input>
    </el-form-item>
    <el-form-item label="项目名称:" prop="projectType"   label-width="120px"  class="width1">
      <el-select  v-model="goodform.projectType" filterable  placeholder="请选择">
        <el-option v-for="item in XMlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="业务类型:" label-width="120px" class="width1">
      <el-select  v-model="goodform.orderBusinessType"  placeholder="请选择">
        <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="提货仓库:" prop="pickupWarehouse"  label-width="120px" class="width1">
      <el-select  v-model="goodform.pickupWarehouse"  placeholder="请选择">
          <el-option  label="本库" value="本库" ></el-option>
          <el-option  label="外库" value="外库" ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="销售合同:"  class="width1 jiage" label-width="120px">
      <el-input  placeholder="" class="disabled" :readonly="true"    maxlength="50" v-model="goodform.salesContract"  ></el-input>
       <el-button type="text" class="danwei" @click="xuanzeHT" style="margin-top: 8px;">选择</el-button>
    </el-form-item>
    <!-- <el-form-item label="合同结束日期:"  label-width="120px" class="width1" v-if="goodform.salesContract">
      <div style="width:260px">{{goodform.contractEndDate|dateFormat1}}</div>
    </el-form-item>
    <el-form-item label="合同提醒天数:" prop="contractReminderDays" v-if="goodform.salesContract" :rules="goodform.salesContract ? rules.contractReminderDays:[{required: false}]"  label-width="120px" class="width1">
      <el-input  placeholder=""  maxlength="50"  v-model="goodform.contractReminderDays"></el-input>
    </el-form-item>
     <el-form-item label="账期预警节点" prop="accountNodeSet"  class="width1" label-width="120px" >
      <el-select  v-model="goodform.accountNodeSet"  placeholder="请选择">
          <el-option  label="装船" value="0" ></el-option>
          <el-option  label="到港" value="1" ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="账期预警天数:" prop="accountReminderDays" v-if="goodform.accountNodeSet" :rules="goodform.accountNodeSet ?  { required: true, message: '请输入账期预警天数', trigger: 'blur' }:[{required: false}]"  label-width="120px" class="width1">
      <el-input  placeholder=""  maxlength="50"  v-model="goodform.accountReminderDays"></el-input>
    </el-form-item> -->
    <el-form-item label="业务部门:" prop="insuranceInfo"   label-width="120px" class="width1">
      <div style="width:260px">{{goodform.businessSubunit}}</div>
    </el-form-item>
    <el-form-item label="业务人员:" prop="businessUserId" label-width="120px" class="width1">
      <div v-if="ywyhFlag">{{goodform.businessUser}}</div>
      <el-select  v-else v-model="goodform.businessUserId" filterable placeholder="请选择" @change="yonghuChange">
        <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item label="业务人员:" prop="insuranceInfo"   >
      <div>{{goodform.businessUser}}</div>
    </el-form-item> -->

    <hr>
    <!-- 地址组件 -->
    <addDizhi :goodform="goodform" ></addDizhi>
    <hr>
    <!-- 添加货物外库 -->
    <addGoodWaiku :goodform="goodform" :glhwFlag="glhwFlag" ></addGoodWaiku>
     <div class="addressBox" style="margin-top:20px">
         <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>运输要求</span>
        </h4>
        <el-form-item label="要求到达时间:" prop="arrivalTime" label-width="120px">
            <el-date-picker
              v-model="goodform.arrivalTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetime"
                placeholder="选择日期时间"
                 :picker-options="pickerOptions"
            ></el-date-picker>
        </el-form-item>
        <el-form-item label="需求车型:"   >
          <el-select  v-model="goodform.requiredModel" filterable placeholder="请选择">
            <el-option v-for="item in CXlist" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="需求车长:"   >
          <el-select  v-model="goodform.needLength" filterable placeholder="请选择">
            <el-option v-for="item in CClist" :label="item.name+'米'" :value="item.name+'米'" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回单要求:" prop="receiptRequest"   >
          <el-select  v-model="goodform.receiptRequest"  placeholder="请选择">
             <el-option  label="纸质回单" value="纸质回单" ></el-option>
             <el-option  label="电子回单" value="电子回单" ></el-option>
             <el-option  label="否" value="否" ></el-option>
          </el-select>
        </el-form-item>
        <br>
        <el-form-item label="提货到场时间:" label-width="120px">
            <el-date-picker
              v-model="goodform.pickupTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="提货紧急程度:" label-width="160px">
          <el-radio-group v-model="goodform.urgencyFlag"    >
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">紧急</el-radio>
            <el-radio :label="2">加急</el-radio>
          </el-radio-group>
        </el-form-item>
        <br>
        <div>
          <el-tag style="margin:10px 10px;cursor: pointer;" v-for="item in elTags"
            :key="item"   @click="tagClick(item)" effect="plain">
            {{ item}}
          </el-tag>
        </div>
        <el-form-item label="备注" class="remark" prop="remark" label-width="58px">
          <el-input  placeholder=""  maxlength="500" @blur="remarkFn" v-model="goodform.remark"></el-input>
        </el-form-item>
      </div>
      <shouru :goodform="goodform"></shouru>
      <hr>
      <div class="addressBox inpBox" >
        <h4 class="title">
          <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>支出信息</span><span class="red" style="font-size: 12px;">(订单如需转包，需填写运费信息)</span>
        </h4>
        <zhichu :goodform="goodform" ></zhichu>
      </div>
      <hr>
      <uploadFiles :fileArr.sync='fileArr' :max=10></uploadFiles>

  </el-form>
  <div class="footerBtn">
    <el-button  class="bigBtn"  btnCode="004P001B001"  @click="back">取消</el-button>
    <el-button type="primary" class="bigBtn"  btnCode="004P001B000"  @click="saveFn(1)">提交</el-button>
    <el-button type="primary" class="bigBtn"  btnCode="004P001B000"  @click="saveFn(2)">复制建单</el-button>
  </div>
  <!-- 关联合同 -->
  <guanlianhetong :goodform="goodform" v-if="GLHTflag" :GLHTflag.sync='GLHTflag'></guanlianhetong>
</div>
</template>

<script>
import { selectTMSTenantListByCustom, getDepartmentUsers } from '@/api/newCrm'
import { getDictionaryDetailList, findCustomerInfoList, addOrder, getOrderInfo } from '@/api/newTMS'
import { cVLlist, cVTlist } from '@/api/vgs-driver2.0'
import addDizhi from '@/views/newTMS/publicFiles/wayAndOrder/addDizhi.vue'
import addGoodWaiku from '@/views/newTMS/publicFiles/wayAndOrder/addGoodWaiku.vue'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
import guanlianhetong from '@/views/newTMS/publicFiles/wayAndOrder/guanlianhetong.vue'
import shouru from '@/views/newTMS/publicFiles/wayAndOrder/shouru.vue'
import zhichu from '@/views/newTMS/publicFiles/wayAndOrder/zhichu.vue'
export default {
  components: {
    addDizhi, addGoodWaiku, uploadFiles, guanlianhetong, shouru, zhichu
  },
  data () {
    return {
      id: this.$route.query.id,
      glhwFlag: this.$route.query.flag.toString(),
      goodform: {
        goodsList: [],
        measuringUnit: '吨',
        incomePattern: '0',
        makeTicketYn: '是',
        ticketSystemYn: '否',
        revenueValuation: '0',
        urgencyFlag: 0
      },
      rules: {
        projectType: [
          { required: true, message: '请选择项目名称', trigger: 'blur' }
        ],
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        orderBusinessType: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        orderWeight: [
          { required: true, message: '请输入货量', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择要求到达时间', trigger: 'blur' }
        ],
        businessUserId: [
          { required: true, message: '请选择业务人员', trigger: 'blur' }
        ],
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ],
        pickupWarehouse: [
          { required: true, message: '请选择提货仓库', trigger: 'blur' }
        ],
        taxRate: [
          { required: true, message: '请输入收入税率', trigger: 'blur' }
        ],
        contractReminderDays: [
          { required: true, message: '请输入合同提醒天数', trigger: 'blur' }
        ]
      },
      kehuList: [], // 结算客户
      YWLXlist: [], // 业务类型
      CXlist: [], // 车型
      CClist: [], // 车长
      fileArr: [],
      GLHTflag: false, // 关联合同
      yonghuList: [],
      ywyhFlag: false, // 客户身上是否有业务用户
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      elTags: ['需要架子', '需要棉被'],
      tagArr: [],
      XMlist: []
    }
  },
  created () {
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.XMlist = res })

    cVTlist().then(res => { this.CXlist = res })
    cVLlist().then(res => { this.CClist = res })
    getDepartmentUsers({ subOrgCode: localStorage.getItem('orgSubCode'), bussinessUserFlag: 1 }).then(res => { this.yonghuList = res })
    if (this.id) { // 列表复制按钮跳转过来
      getOrderInfo({ orderBusinessId: this.id }).then(res => {
        this.goodform = res.tOrder
        // this.$set(this.goodform, 'payee', res.tOrderBusiness.payee)
        delete this.goodform.orderId
        delete this.goodform.id
        delete this.goodform.updateTime
        delete this.goodform.updateUser
        delete this.goodform.updateUserId
        delete this.goodform.createTime
        delete this.goodform.createUser
        delete this.goodform.createUserId
        delete this.goodform.accomplishedAmount

        if (this.goodform.pickupTimeStart) {
          this.$set(this.goodform, 'pickupTime', [this.goodform.pickupTimeStart, this.goodform.pickupTimeEnd])
        }
        this.$set(this.goodform, 'kilometres', res.tOrder.kilometres.toString())
        this.$set(this.goodform, 'orderBusinessType', res.tOrder.orderBusinessType.toString())
        this.$set(this.goodform, 'productType', res.tOrder.productType.toString())
        this.$set(this.goodform, 'goodsList', [])
        this.$set(this.goodform, 'orderWeight', '')
        this.$set(this.goodform, 'weight', '')
        this.$set(this.goodform, 'volumn', '')
        this.$set(this.goodform, 'orderNumber', '')
        if (res.tOrderBusiness.incomePattern.toString()) {
          this.$set(this.goodform, 'incomePattern', res.tOrderBusiness.incomePattern.toString())
          this.$set(this.goodform, 'incomePatternName', res.tOrderBusiness.incomePatternName)
        }
        if (res.tOrderBusiness.revenueValuation.toString()) {
          this.$set(this.goodform, 'revenueValuation', res.tOrderBusiness.revenueValuation.toString())
          this.$set(this.goodform, 'revenueValuationName', res.tOrderBusiness.revenueValuationName)
        }
        this.$set(this.goodform, 'makeTicketYn', res.tOrderBusiness.makeTicketYn)
        this.$set(this.goodform, 'ticketSystemYn', res.tOrderBusiness.ticketSystemYn)
        this.$set(this.goodform, 'incomeUnitPrice', res.tOrderBusiness.incomeUnitPrice / 100)
        this.$set(this.goodform, 'incomeAmount', res.tOrderBusiness.incomeAmount / 100)
        this.$set(this.goodform, 'payee', res.tOrderBusiness.payee)
        this.$set(this.goodform, 'payeeTaxId', res.tOrderBusiness.payeeTaxId)
        this.$set(this.goodform, 'payeeCode', res.tOrderBusiness.payeeCode)
        this.$set(this.goodform, 'taxRate', res.tOrderBusiness.taxRate)
        this.goodform.settlementCustomersCode = res.tOrderBusiness.settlementCustomersCode

        // 判断业务用户是否可选
        findCustomerInfoList({ businessType: 1 }).then(res => {
          selectTMSTenantListByCustom(res).then(res1 => {
            this.kehuList = res1
            let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
            if (json[0].businessUserCode) {
              this.ywyhFlag = true
            } else {
              this.ywyhFlag = false
            }
            // 业务子部门跟当前登录用户不一样
            if (localStorage.getItem('orgSubCode') != this.goodform.businessSubunitCode) {
              // 业务部门取当前登录用户
              this.$set(this.goodform, 'businessUnit', localStorage.getItem('orgName'))
              this.$set(this.goodform, 'businessUnitCode', localStorage.getItem('orgCode'))
              this.$set(this.goodform, 'businessSubunit', localStorage.getItem('orgSubName'))
              this.$set(this.goodform, 'businessSubunitCode', localStorage.getItem('orgSubCode'))
              this.$set(this.goodform, 'businessTenantCode', localStorage.getItem('tenantCode'))
              this.$set(this.goodform, 'businessTenantName', localStorage.getItem('tenantName'))
              this.$set(this.goodform, 'businessCompanyName', localStorage.getItem('companyName'))
              this.$set(this.goodform, 'businessCompanyCode', localStorage.getItem('companyCode'))
              // 清空业务人员
              this.$set(this.goodform, 'businessUserId', null)
              this.$set(this.goodform, 'businessUser', null)
            }
            this.goodform.periodDays = json[0].periodDays
            this.goodform.periodDaysType = json[0].periodDaysType
          })
        })
      })
    } else {
      this.$set(this.goodform, 'taxRate', 9)
      findCustomerInfoList({ businessType: 1 }).then(res => {
        selectTMSTenantListByCustom(res).then(res1 => { this.kehuList = res1 })
      })
      this.$set(this.goodform, 'businessUnit', localStorage.getItem('orgName'))
      this.$set(this.goodform, 'businessUnitCode', localStorage.getItem('orgCode'))
      this.$set(this.goodform, 'businessSubunit', localStorage.getItem('orgSubName'))
      this.$set(this.goodform, 'businessSubunitCode', localStorage.getItem('orgSubCode'))
      this.$set(this.goodform, 'businessTenantCode', localStorage.getItem('tenantCode'))
      this.$set(this.goodform, 'businessTenantName', localStorage.getItem('tenantName'))
      this.$set(this.goodform, 'businessCompanyName', localStorage.getItem('companyName'))
      this.$set(this.goodform, 'businessCompanyCode', localStorage.getItem('companyCode'))
    }
  },
  mounted () {

  },
  methods: {
    tagClick (item) {
      this.tagArr.push(item)
      this.tagArr = Array.from(new Set(this.tagArr))
      this.$set(this.goodform, 'remark', this.tagArr.toString())
    },
    remarkFn () {
      if (!this.goodform.remark) {
        this.tagArr = []
      }
    },
    SHYJchange () {
      let arr = [].concat(this.checkList)
      let n = this.checkList.indexOf('其他')
      if (n == -1) {
        this.qita = false
        this.addFrom.auditOpinion = arr.toString()
      } else {
        this.qita = true
        arr.splice(n, 1)
        this.addFrom.auditOpinion = arr.toString()
      }
    },
    // 选择用户
    yonghuChange (e) {
      let json = this.yonghuList.filter(item => item.userCode == e)
      this.$set(this.goodform, 'businessUser', json[0].userName)
    },
    // 选择结算客户
    jiesuanChange () {
      let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
      this.goodform.payCustomerId = json[0].id
      this.goodform.payeeTaxId = json[0].customerTaxId
      this.goodform.salesContract = ''
      this.goodform.periodDays = json[0].periodDays
      this.goodform.periodDaysType = json[0].periodDaysType
      if (json[0].businessUserCode) {
        this.ywyhFlag = true
        this.$set(this.goodform, 'businessUserId', json[0].businessUserCode)
        this.$set(this.goodform, 'businessUser', json[0].businessUserName)
      } else {
        this.ywyhFlag = false
        this.$set(this.goodform, 'businessUserId', null)
        this.$set(this.goodform, 'businessUser', null)
      }

      this.goodform.originalCustomer = this.goodform.payee// 下单客户
    },
    xuanzeHT () {
      if (this.goodform.payee) {
        let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
        this.goodform.payCustomerId = json[0].id
        this.GLHTflag = true
      } else {
        this.$alert('请先选择结算客户', '系统提示')
      }
    },
    saveFn (n) {
      const newArr = this.goodform.goodsList.map(item => item.cargoBarcode)
      const arrSet = new Set(newArr)
      if (arrSet.size !== newArr.length) {
        this.$alert('捆包号不能重复', '系统提示')
        return
      }
      if (!this.goodform.kilometres) {
        this.$alert('公里数不能为空，请联系系统管理员', '系统提示')
        return
      }
      if (!this.goodform.deliverAddressId) {
        this.$alert('请选择发货地址', '系统提示')
        return
      }
      if (!this.goodform.receivingAddressId) {
        this.$alert('请选择收货地址', '系统提示')
        return
      }
      if (!this.goodform.orderWeight) {
        this.$alert('订单量不能为0', '系统提示')
        return
      }
      let yewuleixingJson = this.YWLXlist.filter(item => item.itemNo == this.goodform.orderBusinessType)
      if (yewuleixingJson.length > 0) {
        this.goodform.orderBusinessTypeName = yewuleixingJson[0].showName
      } else {
        this.$set(this.goodform, 'orderBusinessType', null)
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.goodform.pickupTime) {
            this.goodform.pickupTimeStart = this.goodform.pickupTime[0]
            this.goodform.pickupTimeEnd = this.goodform.pickupTime[1]
          }
          let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
          if (json.length > 0) {
            this.goodform.payeeTaxId = json[0].customerTaxId
            this.goodform.settlementCustomersCode = json[0].tenantCode
          }

          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify(this.goodform))
          this.fileArr.forEach(item => {
            imgfile.append('files', item.raw)
          })
          addOrder(imgfile).then(res => {
            loading.close()
            if (n == 1) {
              this.$router.push({ name: 'qiYunOrder' })
            } else {
              this.$set(this.goodform, 'goodsList', [])
              this.$set(this.goodform, 'weight', '')
              this.$set(this.goodform, 'orderWeight', '')
              this.$set(this.goodform, 'volumn', '')
              this.$set(this.goodform, 'orderNumber', '')
              this.fileArr = []
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
.width1  /deep/.el-input__inner{
  width: 260px;
}
.disabled /deep/.el-input__inner {
    background: #eff0f1;
}
hr{
  margin-bottom: 20px;
}
/deep/.remark .el-input .el-input__inner{
  width: 788px;
}
/deep/.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
/deep/.el-range-editor{
  width: 430px;
}
</style>
